"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHVACRawData = exports.HVACRawDataType = void 0;
const react_1 = require("react");
var HVACRawDataType;
(function (HVACRawDataType) {
    HVACRawDataType["AirHandler"] = "airHandler";
    HVACRawDataType["HumiditySR"] = "humiditySR";
    HVACRawDataType["FanSpeed"] = "fanSpeed";
    HVACRawDataType["FanSpeedRaw"] = "fanSpeedRaw";
    HVACRawDataType["TotalPower"] = "totalPower";
    HVACRawDataType["TotalCooling"] = "totalCooling";
    HVACRawDataType["CondensorAmperage"] = "condensorAmperage";
    HVACRawDataType["airHandlerAmperage"] = "airHandlerAvgAmperage";
    HVACRawDataType["InstantSeer"] = "instantSeer";
})(HVACRawDataType = exports.HVACRawDataType || (exports.HVACRawDataType = {}));
const useHVACRawData = (seerData) => (0, react_1.useMemo)(() => {
    if (!seerData)
        return [];
    const isValidNumber = (value) => value !== undefined && value !== null && !isNaN(value);
    // The resolver sends 0 for a side with no valid readings (e.g. a return probe
    // sending -999), so 0 means "no reading" here, never 0 °F or 0 %.
    const formatSide = (value, unit) => isValidNumber(value) && Number(value) > 0 ? `${Number(value).toFixed(1)}${unit}` : '-';
    const last = seerData?.lastMinuteSeerRating;
    return [
        {
            id: '1',
            name: HVACRawDataType.InstantSeer,
            value: isValidNumber(seerData?.instantSeerRating)
                ? Number(seerData.instantSeerRating) < 1
                    ? '-'
                    : `${Number(seerData.instantSeerRating).toFixed(1)} EER`
                : '-',
            timestamp: seerData?.timestamp || null,
        },
        {
            id: '2',
            name: HVACRawDataType.AirHandler,
            value: `${formatSide(last?.avgSupplyTempF, ' °F')} | ${formatSide(last?.avgReturnTempF, ' °F')}`,
            timestamp: seerData?.timestamp || null,
        },
        {
            id: '3',
            name: HVACRawDataType.HumiditySR,
            value: `${formatSide(last?.avgSupplyHumidity, '%')} | ${formatSide(last?.avgReturnHumidity, '%')}`,
            timestamp: seerData?.timestamp || null,
        },
        {
            id: '4',
            name: HVACRawDataType.FanSpeed,
            value: isValidNumber(seerData?.lastMinuteSeerRating?.avgFlow)
                ? `${Math.round(Number(seerData.lastMinuteSeerRating?.avgFlow))} CFM`
                : '-',
            timestamp: seerData?.timestamp || null,
        },
        {
            id: '5',
            name: HVACRawDataType.FanSpeedRaw,
            value: isValidNumber(seerData?.lastMinuteSeerRating?.avgFlowRaw)
                ? `${Number(seerData.lastMinuteSeerRating?.avgFlowRaw).toFixed(2)} fps`
                : '-',
            timestamp: seerData?.timestamp || null,
        },
        {
            id: '6',
            name: HVACRawDataType.CondensorAmperage,
            value: isValidNumber(seerData?.lastMinuteSeerRating?.condenserAvgAmperage)
                ? `${Number(seerData.lastMinuteSeerRating?.condenserAvgAmperage).toFixed(1)} A`
                : '-',
            timestamp: seerData?.timestamp || null,
        },
        {
            id: '7',
            name: HVACRawDataType.airHandlerAmperage,
            value: isValidNumber(seerData?.lastMinuteSeerRating?.airHandlerAvgAmperage)
                ? `${Number(seerData.lastMinuteSeerRating?.airHandlerAvgAmperage).toFixed(1)} A`
                : '-',
            timestamp: seerData?.timestamp || null,
        },
        {
            id: '8',
            name: HVACRawDataType.TotalPower,
            value: isValidNumber(seerData?.lastMinuteSeerRating?.powerWattHours)
                ? `${Number(seerData.lastMinuteSeerRating?.powerWattHours).toFixed(1)} W`
                : '-',
            timestamp: seerData?.timestamp || null,
        },
        {
            id: '9',
            name: HVACRawDataType.TotalCooling,
            value: isValidNumber(seerData?.lastMinuteSeerRating?.coolingOutput)
                ? `${Math.round(Number(seerData.lastMinuteSeerRating?.coolingOutput))} BTU/hr`
                : '-',
            timestamp: seerData?.timestamp || null,
        },
    ];
}, [seerData]);
exports.useHVACRawData = useHVACRawData;
